import {Action} from '@ngrx/store';
import {Department, ISRDetail, IScheduleRotation, IShift} from '@signal/asp-data-commons';
import {Update} from '@ngrx/entity';

export enum ScheduleRotationActionTypes {
  LOAD_SCHEDULE_ROTATION = '[Schedule rotation] Load schedule rotation',
  LOAD_SCHEDULE_ROTATION_SUCCESS = '[Employee API] Load schedule rotation success',
  LOAD_SCHEDULE_ROTATION_FAILURE = '[Employee API] Load schedule rotation failure',
  ADD_SCHEDULE_ROTATION = '[Schedule rotation] Add schedule rotation',
  ADD_SCHEDULE_ROTATION_SUCCESS = '[Schedule rotation] Add schedule rotation success',
  ADD_SCHEDULE_ROTATION_FAILURE = '[Schedule rotation] Add schedule rotation failure',
  UPDATE_SCHEDULE_ROTATION_NAME = '[Schedule rotation] Update schedule name rotation',
  UPDATE_SCHEDULE_ROTATION_NAME_SUCCESS = '[Schedule rotation] Update schedule rotation name success',
  UPDATE_SCHEDULE_ROTATION_NAME_FAILURE = '[Schedule rotation] Update schedule rotation name failure',
  DELETE_SCHEDULE_ROTATION = '[Schedule rotation] Delete schedule rotation',
  DELETE_SCHEDULE_ROTATION_SUCCESS = '[Schedule rotation] Delete schedule rotation success',
  DELETE_SCHEDULE_ROTATION_FAILURE = '[Schedule rotation] Delete schedule rotation failure',
  UPDATE_SCHEDULE_ROTATION = '[Schedule rotation] Update schedule rotation',
  UPDATE_START_DATE = '[Schedule rotation] Update start week',
  SAVE_SCHEDULE_ROTATION = '[Schedule rotation] Save schedule rotation',
  SAVE_SCHEDULE_ROTATION_SUCCESS = '[Employee API] Save schedule rotation success',
  SAVE_SCHEDULE_ROTATION_FAILURE = '[Employee API] Save schedule rotation failure',
  ADD_WEEK = '[Schedule rotation] Add a week',
  DELETE_WEEK = '[Schedule rotation] Delete a week',
  ADD_SHIFT = '[Schedule rotation] Add a shift',
  UPDATE_SHIFT = '[Schedule rotation] Update a shift',
  DELETE_SHIFT = '[Schedule rotation] Delete a shift',
}

export class LoadScheduleRotation implements Action {
  readonly type = ScheduleRotationActionTypes.LOAD_SCHEDULE_ROTATION;

  constructor(public payload: { department: Department }) {
  }
}

export class LoadScheduleRotationSuccess implements Action {
  readonly type = ScheduleRotationActionTypes.LOAD_SCHEDULE_ROTATION_SUCCESS;

  constructor(public payload: { scheduleRotation: {[key:string]:IScheduleRotation}, department: Department }) {
  }
}

export class LoadScheduleRotationFailure implements Action {
  readonly type = ScheduleRotationActionTypes.LOAD_SCHEDULE_ROTATION_FAILURE;

  constructor(public payload: { error: string, department: Department }) {
  }
}

export class AddScheduleRotation implements Action {
  readonly type = ScheduleRotationActionTypes.ADD_SCHEDULE_ROTATION;

  constructor(public payload: { department: Department, name: string, payload: IScheduleRotation }) {
  }
}

export class AddScheduleRotationSuccess implements Action {
  readonly type = ScheduleRotationActionTypes.ADD_SCHEDULE_ROTATION_SUCCESS;

  constructor(public payload: { department: Department, scheduleRotation: IScheduleRotation }) {
  }
}

export class AddScheduleRotationFailure implements Action {
  readonly type = ScheduleRotationActionTypes.ADD_SCHEDULE_ROTATION_FAILURE;

  constructor(public payload: { department: Department, error: string }) {
  }
}

export class UpdateScheduleRotationName implements Action {
  readonly type = ScheduleRotationActionTypes.UPDATE_SCHEDULE_ROTATION_NAME;

  constructor(public payload: { department: Department, id: string, name: string }) {
  }
}

export class UpdateScheduleRotationNameSuccess implements Action {
  readonly type = ScheduleRotationActionTypes.UPDATE_SCHEDULE_ROTATION_NAME_SUCCESS;

  constructor(public payload: { department: Department, scheduleRotation: IScheduleRotation }) {
  }
}

export class UpdateScheduleRotationNameFailure implements Action {
  readonly type = ScheduleRotationActionTypes.UPDATE_SCHEDULE_ROTATION_NAME_FAILURE;

  constructor(public payload: { department: Department, error: string }) {
  }
}


export class DeleteScheduleRotation implements Action {
  readonly type = ScheduleRotationActionTypes.DELETE_SCHEDULE_ROTATION;

  constructor(public payload: { department: Department, id: string }) {
  }
}

export class DeleteScheduleRotationSuccess implements Action {
  readonly type = ScheduleRotationActionTypes.DELETE_SCHEDULE_ROTATION_SUCCESS;

  constructor(public payload: { department: Department, scheduleRotation: IScheduleRotation }) {
  }
}

export class DeleteScheduleRotationFailure implements Action {
  readonly type = ScheduleRotationActionTypes.DELETE_SCHEDULE_ROTATION_FAILURE;

  constructor(public payload: { department: Department, error: string }) {
  }
}

export class UpdateScheduleRotation implements Action {
  readonly type = ScheduleRotationActionTypes.UPDATE_SCHEDULE_ROTATION;

  constructor(public payload: { id: string, weeklyRotations: ISRDetail[], day: string, index: number, department: Department, shiftId: string }) {
  }
}

export class UpdateStartDate implements Action {
  readonly type = ScheduleRotationActionTypes.UPDATE_START_DATE;

  constructor(public payload: { id: string, startDate: string, department: Department }) {
  }
}

export class SaveScheduleRotation implements Action {
  readonly type = ScheduleRotationActionTypes.SAVE_SCHEDULE_ROTATION;

  constructor(public payload: { scheduleRotation: IScheduleRotation, department: Department }) {
  }
}

export class SaveScheduleRotationSuccess implements Action {
  readonly type = ScheduleRotationActionTypes.SAVE_SCHEDULE_ROTATION_SUCCESS;

  constructor(public payload: { scheduleRotation: IScheduleRotation, department: Department }) {
  }
}

export class SaveScheduleRotationFailure implements Action {
  readonly type = ScheduleRotationActionTypes.SAVE_SCHEDULE_ROTATION_FAILURE;

  constructor(public payload: { error: string, department: Department }) {
  }
}

export class AddWeek implements Action {
  readonly type = ScheduleRotationActionTypes.ADD_WEEK;

  constructor(public payload: { id: string, department: Department }) {
  }
}

export class DeleteWeek implements Action {
  readonly type = ScheduleRotationActionTypes.DELETE_WEEK;

  constructor(public payload: { id: string; department: Department, weekIndex: number }) {
  }
}

export class AddShift implements Action {
  readonly type = ScheduleRotationActionTypes.ADD_SHIFT;

  constructor(public payload: { department: Department, id: string, shift: IShift }) {
  }
}

export class UpdateShift implements Action {
  readonly type = ScheduleRotationActionTypes.UPDATE_SHIFT;

  constructor(public payload: { id: string, department: Department, updateShift: Update<IShift> }) {
  }
}

export class DeleteShift implements Action {
  readonly type = ScheduleRotationActionTypes.DELETE_SHIFT;

  constructor(public payload: { id: string; department: Department, shiftId: string }) {
  }
}

export type ScheduleRotationActions =
  LoadScheduleRotation
  | LoadScheduleRotationSuccess
  | LoadScheduleRotationFailure
  | AddScheduleRotation
  | AddScheduleRotationSuccess
  | AddScheduleRotationFailure
  | UpdateScheduleRotationName
  | UpdateScheduleRotationNameFailure
  | UpdateScheduleRotationNameSuccess
  | DeleteScheduleRotation
  | DeleteScheduleRotationFailure
  | DeleteScheduleRotationSuccess
  | UpdateStartDate
  | UpdateScheduleRotation
  | SaveScheduleRotation
  | SaveScheduleRotationSuccess
  | SaveScheduleRotationFailure
  | AddWeek
  | DeleteWeek
  | AddShift
  | UpdateShift
  | DeleteShift
  ;
